import "./00-jwplayer";
import SSSlideDisplayer from "./00-slideshare_slide_displayer";

function SSVideoDisplayer(config) {
  SSSlideDisplayer.call(this, config);
}

SSVideoDisplayer.prototype = new SSSlideDisplayer();

SSVideoDisplayer.prototype.showInitializer = function() {
  var top, left, that = this;
  top = this.container.height()/2 - 16;
  left = this.container.width()/2 - 16;

  $('<img/>').attr({src: this.config.spinnerUrl}).css({
    width : 32,
    height : 32,
    top : top,
    left : left,
    position : 'absolute'
  }).appendTo(this.container);

  if(this.config.isMobileDevice) {
    this.fakeClicker = $('<div/>').addClass('fakeClicker');
    $('<img/>').attr('src', this.config.playIcon).addClass('contentPlayIcon').appendTo(this.fakeClicker);

    this.fakeClicker.appendTo($('.slideShow.video'));

    $('.fakeClicker').on('click', function(e) {
      if(that.config.isMobileAndNonIos) {
        if(that.userClickedOnAndroid) {
          that.fakeClicker.hide();
          $('.slideDisplayer').css('-webkit-transform', 'translateX(0px)');
        }
        that.videoPlayer.play(true);
        that.userClickedOnAndroid = true;
      } else {
        that.videoPlayer.play(true);
        $('.fakeClicker img.contentPlayIcon').attr('src', that.config.spinnerUrl);
      }
      var vid = document.getElementsByTagName("video")[0];
      vid && vid.play();
    });
  }
};

SSVideoDisplayer.prototype.setDimensions = function(dimensions) {
  this.height = dimensions.height;
  this.width = dimensions.width;
  this.container.css({
    height : this.height,
    width : this.width
  });
};

SSVideoDisplayer.prototype.start = function(config) {
  this.slidesContainer = $('<div/>').attr({
    'class' : 'slidesContainer',
    'id' : 'videoSlideContainer_' + this.config.screenMode
  }).addClass('slidesContainer ' + this.playerBgColor).appendTo(this.container);
  this.videoSpinner = this.container.children('img').attr('src', this.config.videoSpinner);

  this.setupVideoPlayer();
};

SSVideoDisplayer.prototype._scrollTo = function(data) {
};

SSVideoDisplayer.prototype.emptySlides = function() {
};

SSVideoDisplayer.prototype.setupVideoPlayer = function(w, h) {
  // Check to ensure plugin is initialized only once
  var that = this;
  if(!this.videoPlayer) {
    // sample url
    // "//video.slideshare.s3.amazonaws.com/colaborao-wikiecrowdsourcing-120413003159-phpapp01-video-SD.mp4"
    var videoUrl = this.config.videoBucket + '/' + this.config.pptLocation + '-SD.' + this.config.videoExtension;
    var autoplayEnabled = window.slideshare_object.user.loggedin !== undefined || $.cookie('sso_redirect') === 'true';
    var posterImage = (this.config.isEmbed ? window.location.protocol + this.config.posterImage : '');
    this.playerModes = [
      { type: "html5" }
    ];
    this.videoPlayer = window.jwplayer("videoSlideContainer_" + this.config.screenMode).setup({
      file: videoUrl,
      icons: false,
      controlbar: {
        position: 'bottom',
        idlehide: false
      },
      autoplay: autoplayEnabled,
      modes: that.playerModes,
      height: h || this.height,
      width: w || this.width,
      image: posterImage,
      events: {
        onReady: function() {
          $.slideshareEventManager.trigger('videoready', { mode: that.config.screenMode });
        }
      },
      autostart: autoplayEnabled
    });

    !this.config.useDefaultToolbar && this.videoPlayer.getPlugin("controlbar").hide();
    // Have to enable the toolbar for it to be shown in older browsers. Hide it in newer ones.
  }

  // Additional handling for IE. video area doesn't respond to clicks.
  if(this.config.ieAndLessThan8) {
    $("#" + this.config.playerDomName).on('click', "video", function(e){
      e.preventDefault();
      that.videoPlayer && that.videoPlayer.play();
    });
  }
  this.config.isMobileAndNonIos && this.fakeClicker.trigger('click');
};

SSVideoDisplayer.prototype.adjustSpinnerPosition = function(isVideoFullscreen) {
  var loaderElement = this.videoSpinner;
  if(isVideoFullscreen) {
    this.originalLeftForSpinner = parseInt(loaderElement.css('left'), 10);
    this.originalTopForSpinner = parseInt(loaderElement.css('top'), 10);
    var fullscreenLeft = $(window).width() / 2;
    var fullscreenTop = ($(window).height() - this.config.toolbarHeight) / 2;
    loaderElement.css({
      left: fullscreenLeft,
      top: fullscreenTop
    });
  } else {
    loaderElement.css({
      left: this.originalLeftForSpinner,
      top: this.originalTopForSpinner
    });
  }
};

export default SSVideoDisplayer;
